import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PowerFactorsReportDialog from "../components/PowerFactorsReportDialog";


export default function PowerFactorsPage({ deviceType = "analyzer" }) {
  const { t } = useTranslation();
  const { deviceId } = useParams();
  const [data, setData] = useState({});
  const [reportOpen, setReportOpen] = useState(false);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const ENDPOINT_PREFIX =
    deviceType === "reactive" ? "/reactive" : "/measurements";

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          `${API_BASE}${ENDPOINT_PREFIX}/power-factors?deviceId=${deviceId}`
        );
        const json = await res.json();
        //console.log(res);
        setData(json);
      } catch (err) {
        console.error("fetch power factors error:", err);
      }
    }
    fetchData();
    const i = setInterval(fetchData, 15000);
    return () => clearInterval(i);
  }, [deviceId, API_BASE]);

  return (
    <div className="p-6 grid grid-cols-2 md:grid-cols-3 gap-6">
      <Card title={t('powerFactors.PF1')} value={data.PFmean1} />
      <Card title={t('powerFactors.PF2')} value={data.PFmean2} />
      <Card title={t('powerFactors.PF3')} value={data.PFmean3} />

      <div className="flex justify-start mt-4">
        <button
          onClick={() => setReportOpen(true)}
          className="bg-sky-600 text-white px-3 py-2 rounded-md hover:bg-sky-700 text-sm"
        >
          {t('powerFactors.reportButton')}
        </button>
      </div>

      <PowerFactorsReportDialog
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        deviceId={deviceId}
        deviceType={deviceType}
        API_BASE={API_BASE}
      />
    </div>

  );
}

function Card({ title, value }) {
  return (
    <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center justify-center">
      <h3 className="text-sm font-medium text-gray-500">{title}</h3>
      <p className="text-2xl font-bold text-gray-800">
        {value != null ? value.toFixed(3) : "-"}
      </p>


    </div>
  );
}
